import React, { useState } from "react";
import avatar from "../../../assets/img/avatar.svg";
import filledStar from "../../../assets/img/filledStar.svg";
import outlineStar from "../../../assets/img/outlineStar.svg";
import ReactStars from "react-rating-stars-component";
import { TextField } from "@material-ui/core";
import api from "../../../config/api";
import { ListBodyItemAction } from "../WidgetsList";
import CircleImage from "../../Image/CircleImage";
// import MaterialIcon from 'material-icons-react';

export function ListComments(props) {
  let pages = [];
  let qtPages = Math.ceil(props.totalItem / props.limit);
  for (let count = 1; count < qtPages + 1; count++) {
    pages.push(count);
  }
  return (
    <div className="row m-0 w-100 ">
      <div
        className={`col-12 col-lg p-3 pb-2 ${
          (props.className !== undefined) & (props.className !== null) ? props.className : ""
        }`}
      >
        {props.children}
      </div>
      <div className="col-12 px-0 d-block d-lg-flex justify-content-between mt-3 m-0 align-items-center">
        <form className="border-auro-metal w-auto br-5">
          <select
            aria-expanded="true"
            onChange={props.onChange}
            value={props.limit}
            className="c-pointer form-select form-select-lg border-0 fz-14 box-shadow-none text-cl-auroMetal ff-univanova-regular notification-scroll"
          >
            <option value="6">Mostrar 06 comentários</option>
            <option value="8">Mostrar 08 comentários</option>
            <option value="16">Mostrar 16 comentários</option>
          </select>
        </form>
        <div className="mt-3 mt-lg-0 d-flex justify-content-around justify-content-lg-between">
          {pages.length > 0 && (
            <span
              onClick={props.prevButton}
              className="text-cl-auroMetal ff-univanova-bold fz-14 t-decoration-none c-pointer"
            >
              Anterior
            </span>
          )}
          {pages.map((item, index) => (
            <span
              onClick={props.changePage}
              id={item}
              className={`${
                props.page === item ? "text-cl-blue" : "text-cl-auroMetal"
              } ff-univanova-bold fz-14 t-decoration-none c-pointer mx-3`}
            >
              {item}
            </span>
          ))}
          {pages.length > 0 && (
            <span
              onClick={props.nextButton}
              className="text-cl-auroMetal ff-univanova-bold fz-14 t-decoration-none ms-2 c-pointer"
            >
              Próximo
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export function ListCommentsItem(props) {
  let options = {
    count: 5,
    value: props.stars,
    edit: false,
    isHalf: false,
    emptyIcon: <img alt="" width={12} height={12} src={outlineStar} />,
    filledIcon: <img alt="" width={12} height={12} src={filledStar} />,
  };
  const [inputReply, setInputReply] = useState(false);
  const [reply, setReply] = useState(props.reply || "");

  const sendReply = () => {
    try {
      api.put(`comment/reply/${props.id}`, { reply: reply }).then((resp) => {
        setInputReply(() => false);
        props.getComments(props.pageComment, props.qtLimitItemComments);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const deleteReply = () => {
    try {
      api.put(`comment/reply/${props.id}`, { reply: "" }).then((resp) => {
        setInputReply(() => false);
        setReply(() => "");
        props.getComments(props.pageComment, props.qtLimitItemComments);
      });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="row m-0 w-100 mt-3">
      <div className="col-12 px-0 d-flex">
        <div className="d-block">
          <CircleImage
            url={props.avatar !== undefined ? (props.avatar !== "" ? props.avatar : avatar) : avatar}
            sizePx={"50px"}
          />
        </div>
        <div className="d-flex flex-column w-100 me-5">
          <span className="text-cl-black ff-univanova-bold fz-14 px-0">
            {props.userName}
            <span className="ms-2 ff-univanova-regular fz-12 text-cl-auroMetal">{props.time}</span>
          </span>
          <textarea
            disabled
            className="text-cl-black ff-univanova-regular fz-14 mb-2 px-0 border-0 bg-transparent"
            value={props.comment}
          ></textarea>
          <div className="d-flex col-12">
            <ReactStars {...options} />
            {props.establishment ? (
              <span
                className="ms-5 c-pointer text-cl-azure"
                onClick={() => {
                  setInputReply(() => true);
                }}
              >
                Responder
              </span>
            ) : (
              <></>
            )}
          </div>
          {inputReply ? (
            <ListCommentsItemInput {...{ reply, setReply, setInputReply, sendReply }} />
          ) : (
            <>
              {props.reply ? (
                <ListCommentsItemReply
                  storeName={props.storeName}
                  setInputReply={setInputReply}
                  deleteReply={deleteReply}
                  reply={props.reply}
                  establishment={props.establishment}
                />
              ) : (
                <></>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
export function ListCommentsItemReply(props) {
  return (
    <div className="d-flex justify-content-start bg-cl-cultured-2 mt-3 w-100 col-12" style={{ padding: "21px 18px" }}>
      <span className="text-cl-black ff-univanova-bold fz-14  me-auto">
        {`Resposta - ${props.storeName} `}
        <span style={{ fontWeight: "500" }} className="ff-univanova-regular  ">
          {props.reply}
        </span>
      </span>
      {props.establishment ? (
        <ListBodyItemAction sizeLg={"auto"} title={"edit"}>
          <li
            onClick={() => {
              props.setInputReply(() => true);
            }}
          >
            <span className="dropdown-item fz-14 ff-univanova-regular c-pointer">Editar</span>
          </li>
          <li onClick={() => props.deleteReply()}>
            <span className="dropdown-item fz-14 ff-univanova-regular text-prop-danger c-pointer  text-cl-red">
              Excluir
            </span>
          </li>
        </ListBodyItemAction>
      ) : (
        <></>
      )}
    </div>
  );
}
export function ListCommentsItemInput(props) {
  return (
    <div className="col-12 my-2 ">
      <TextField
        variant={"outlined"}
        multiline
        minRows={4}
        value={props.reply}
        onChange={(e) => props.setReply(e.target.value)}
        className="fz-16 text-cl-dark-jungle-green ff-univanova col-12"
      />
      <div className={`col-12 col-lg d-flex justify-content-end mt-3`}>
        <button
          onClick={() => {
            props.setInputReply(() => false);
          }}
          className="bg-transparent text-cl-red border-0 me-4 rounded-2 fz-14 d-flex justify-content-center align-items-center ff-univanova-medium py-2 px-4 "
        >
          Cancelar
        </button>
        <button
          onClick={() => props.sendReply()}
          className="btn bg-gradient-theme-blue text-white rounded-2  fz-14 d-flex justify-content-center align-items-center ff-univanova-medium py-2 px-3"
        >
          Enviar resposta
        </button>
      </div>
    </div>
  );
}
